import { render, staticRenderFns } from "./ShopOnShelves.vue?vue&type=template&id=119b59d3&scoped=true"
import script from "./ShopOnShelves.vue?vue&type=script&lang=js"
export * from "./ShopOnShelves.vue?vue&type=script&lang=js"
import style0 from "./ShopOnShelves.vue?vue&type=style&index=0&id=119b59d3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "119b59d3",
  null
  
)

export default component.exports